import { render, staticRenderFns } from "./UserSettingsDialog.vue?vue&type=template&id=7e12de1b"
import script from "./UserSettingsDialog.vue?vue&type=script&lang=ts"
export * from "./UserSettingsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports